import { ErrorMessage, Field } from 'formik';
import Link from 'next/link';

import { Routes } from '~/constants/routes';
import { SIGN_UP_TERMS_INPUT } from '~/constants/testIDs';

/**
 * MailChimp is requiring us to add this to our sign up flow in order to send
 * out marketing campaign. You'll notice that this isn't using any existing component
 * and everything is inline. This is a quick temporary solution until we have a
 * proper checkbox component that lives within Zephyr. (Sorry Kyle)
 */

export const SignUpTermsCheckbox = () => {
  return (
    <label className="mt-12 mb-6 flex text-12 text-grey-11" data-testid={SIGN_UP_TERMS_INPUT} htmlFor="terms">
      <div className="mt-1 mr-2 shrink-0">
        <Field id="terms" type="checkbox" name="terms" required />
      </div>
      <div>
        By signing up, you agree to Air&apos;s <Link href={Routes.marketing.terms}>Terms of Service</Link>,{' '}
        <Link href={Routes.marketing.privacy}>Privacy Policy</Link>, and occasional update emails.
        <ErrorMessage name="terms">{(msg) => <div className="text-12 text-red-9">{msg}</div>}</ErrorMessage>
      </div>
    </label>
  );
};
